document.addEventListener('DOMContentLoaded', function () {
    $(document).on('click', '#select-all', function () {
        const selectItems = $('.remove-cart-items');
        const isChecked = $(this).prop('checked');
        selectItems.prop('checked', isChecked);
        disableDeleteButton(isChecked);
    });

    $(document).on('click', '.remove-cart-items', function () {
        const selectItems = $('.remove-cart-items');
        const selectedItems = selectItems.filter(':checked');
        let isChecked = false;
        if (selectedItems.length) {
            isChecked = true;
        }

        disableDeleteButton(isChecked);
    });

    $(document).on('click', '#delete-all', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }
        $.confirm({
            title: '',
            content: 'Would you like to remove the product(s) from you cart?',
            buttons: {
                ok: {
                    text: "Yes, Remove",
                    btnClass: 'btn-primary',
                    keys: ['enter'],
                    action: function () {
                        proceed()

                    }
                },
                cancel: {
                    text: "Cancel"
                }
            }
        });

        function proceed() {
            const selectItems = $('.remove-cart-items');
            const selectedItems = selectItems.filter(':checked');
            const itemKeys = selectedItems.map(function () {
                return $(this).data('item-key');
            }).get();


            const updates = {};
            itemKeys.forEach(function (itemKey) {
                updates[itemKey] = 0;
            });

            fetch('/cart/update.js', {
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ updates })
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (cart) {
                    smartToast.success({text: 'Item removed successfully'});
                    setTimeout(function() {
                        location.reload();
                    }, 3000)
                    
                })
                .catch(function (error) {
                    console.error('Error:', error);
                });

        }
    });

    // $('body').on('click', '#cart-discount-form .cart__discount-btn', function () {
    //     var discountCode = $('#cart-discount-input').val();
    //     discountCode = discountCode.trim();
    //     let coupon_applied = $('#coupon_applied').val();
    //     if (coupon_applied != '') {
    //         discountCode = discountCode + ',' + coupon_applied;
    //     }

    //     if (discountCode.length) {
    //         localStorage.setItem('last_input_discount', $('#cart-discount-input').val().trim());
    //         $.ajax({
    //             url: '/checkout?discount=' + discountCode,
    //             type: 'GET'
    //         }).always(function () {
    //             fetch('/cart/update.js', {
    //                 credentials: 'same-origin',
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Accept': 'application/json',
    //                     'X-Requested-With': 'XMLHttpRequest'
    //                 },
    //                 body: JSON.stringify({
    //                     updates: {},
    //                 }),
    //             })
    //                 .then(function (response) {
    //                     return response.json();
    //                 })
    //                 .then(function (cart) {
    //                     if (cart.total_discount == 0) {
    //                         $(".discount__total").html('');
    //                     }
    //                     let discountList = [];
    //                     $.each(cart.items, function (key, line_item) {
    //                         if (line_item.line_level_discount_allocations.length > 0) {
    //                             $.each(line_item.line_level_discount_allocations, function (key, discount_allocation) {
    //                                 if (discountList.indexOf(discount_allocation.discount_application.title) === -1 && discount_allocation.discount_application.type == 'discount_code') {
    //                                     discountList.push(discount_allocation.discount_application.title);
    //                                 }
    //                             });
    //                         }
    //                     });
    //                     $.each(cart.cart_level_discount_applications, function (key, discount_application) {
    //                         if (discountList.indexOf(discount_application.discount_application.title) === -1 && discount_application.discount_application.type == 'discount_code') {
    //                             discountList.push(discount_application.discount_application.title);
    //                         }
    //                     });
    //                     let discountCode = $('#cart-discount-input').val().trim();
    //                     if (discountCode && discountList.indexOf(discountCode) > -1) {
    //                         $('.discount-wrapper').removeClass('error-message').addClass('success-message');
    //                         $('.discount-wrapper .success').removeClass('hidden');
    //                         $('.discount-wrapper .error').addClass('hidden');
    //                         $('.discount-message').removeClass('hidden').text('The discount code has been applied.');
    //                         $('.Cart__Total.discount__total span:last').text('-$' + (cart.total_discount / 100).toFixed(2));
    //                         $('.Cart__Total.total__all span:last').text('$' + ((cart.original_total_price - cart.total_discount) / 100).toFixed(2));
    //                         let discountHtml = '';
    //                         $.each(discountList, function (key, dicountCode) {
    //                             discountHtml = discountHtml + '<p type="submit" class="remove-discount-button">' +
    //                                 '<span>' + dicountCode + '</span>' +
    //                                 '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
    //                                 '<g clip-path="url(#clip0_3269_172092)">' +
    //                                 '<path d="M12 4L4 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    //                                 '<path d="M4 4L12 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    //                                 '</g><defs>' +
    //                                 '<clipPath id="clip0_3269_172092">' +
    //                                 '<rect width="16" height="16" fill="white"/></clipPath></defs></svg></p>';
    //                         });
    //                         if (discountHtml) {
    //                             $('.gr__discount__title').html(discountHtml);
    //                         }
    //                         $('#cart-discount-input').val('').removeClass('input-invalid');
    //                         let stringCoupons = discountList.join(",");
    //                         $('#coupon_applied').val(stringCoupons);

    //                     } else {
    //                         if (discountCode) {
    //                             $('.discount-wrapper').removeClass('success-message').addClass('error-message');
    //                             $('.discount-wrapper .success').addClass('hidden');
    //                             $('.discount-wrapper .error').removeClass('hidden');
    //                             $('.discount-message').removeClass('hidden').addClass('error').text('Enter a valid discount code or gift card.');
    //                             $('#cart-discount-input').addClass('input-invalid');
    //                             $('#cart-discount-input').val('');
    //                         }
    //                     }
    //                 })
    //                 .catch(function (error) {
    //                     console.error('Error:', error);
    //                 });
    //         });
    //     } else {
    //       $('.discount-wrapper').removeClass('success-message').removeClass('error-message');
    //        $('.discount-wrapper .success').addClass('hidden');
    //         $('.discount-wrapper .error').addClass('hidden');
    //         $('.discount-message').removeClass('hidden').addClass('error').text('Enter a valid discount code or gift card.');
    //     }
    // });

    // $(document).on('click', '.remove-discount-button', function () {
    //     let coupon_applied = $('#coupon_applied').val();
    //     localStorage.setItem('discount', coupon_applied);
    //     let coupon_removed = $(this).children(":first").text();
    //     var discountCode = $(this).find('span:first').text().trim();
    //     if (coupon_applied != '') {
    //         coupon_applied = coupon_applied.replace(coupon_removed, "");
    //     }
    //     if (coupon_applied.indexOf(',,') != -1) {
    //         coupon_applied = coupon_applied.replace(',,', ',');
    //     }
    //     let lastChar = coupon_applied[coupon_applied.length - 1];

    //     if (lastChar == ',') {
    //         coupon_applied = coupon_applied.slice(0, -1);
    //     }
    //     if (coupon_applied.length) {
    //         $.ajax({
    //             url: '/checkout?discount=' + coupon_applied,
    //             type: 'GET'
    //         }).always(function () {
    //             fetch('/cart/update.js', {
    //                 credentials: 'same-origin',
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Accept': 'application/json',
    //                     'X-Requested-With': 'XMLHttpRequest'
    //                 },
    //                 body: JSON.stringify({
    //                     updates: {},
    //                 }),
    //             })
    //                 .then(function (response) {
    //                     return response.json();
    //                 })
    //                 .then(function (cart) {
    //                     if (cart.total_discount == 0) {
    //                         $(".discount__total").html('');
    //                     } else {
    //                         let discountList = [];
    //                         cart.items.forEach(function (line_item) {
    //                             if (line_item.line_level_discount_allocations.length > 0) {
    //                                 line_item.line_level_discount_allocations.forEach(function (discount_allocation) {
    //                                     if (discountList.indexOf(discount_allocation.discount_application.title) === -1 && discount_allocation.discount_application.type == 'discount_code') {
    //                                         discountList.push(discount_allocation.discount_application.title);
    //                                     }
    //                                 });
    //                             }
    //                         });
    //                         cart.cart_level_discount_applications.forEach(function (discount_application) {
    //                             if (discountList.indexOf(discount_application.discount_application.title) === -1 && discount_application.discount_application.type == 'discount_code') {
    //                                 discountList.push(discount_application.discount_application.title);
    //                             }
    //                         });
    //                         if (discountCode && discountList.indexOf(discountCode) == -1) {
    //                             $('.discount-wrapper').removeClass('error-message').addClass('success-message');
    //                             $('.discount-wrapper .success').removeClass('hidden');
    //                             $('.discount-wrapper .error').addClass('hidden');
    //                             $('.discount-message').removeClass('hidden').text('The discount code has been removed.');
    //                             $('#cart-discount-input').removeClass('input-invalid');
    //                             $('.Cart__Total.discount__total span:last').text('-$' + ((cart.total_discount / 100).toFixed(2)));
    //                             $('.Cart__Total.total__all span:last').text('$' + ((cart.original_total_price - cart.total_discount) / 100).toFixed(2));
    //                             $('#cart-discount-input').val('');
    //                             let stringCoupons = discountList.join(",");
    //                             $('#coupon_applied').val(stringCoupons);
    //                             let discountHtml = '';
    //                             $.each(discountList, function (key, dicountCode) {
    //                                 discountHtml = discountHtml + '<p type="submit" class="remove-discount-button">' +
    //                                     '<span>' + dicountCode + '</span>' +
    //                                     '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
    //                                     '<g clip-path="url(#clip0_3269_172092)">' +
    //                                     '<path d="M12 4L4 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    //                                     '<path d="M4 4L12 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    //                                     '</g><defs>' +
    //                                     '<clipPath id="clip0_3269_172092">' +
    //                                     '<rect width="16" height="16" fill="white"/></clipPath></defs></svg></p>';
    //                             });
    //                             if (discountHtml) {
    //                                 $('.gr__discount__title').html(discountHtml);
    //                             }

    //                         }
    //                     }

    //                 })
    //                 .catch(function (error) {
    //                     console.error('Error:', error);
    //                 });
    //         });
    //     } else {
    //         $.ajax({
    //             url: '/discount/remove/',
    //             type: 'GET'
    //         }).always(function () {
    //             fetch('/cart/update.js', {
    //                 credentials: 'same-origin',
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Accept': 'application/json',
    //                     'X-Requested-With': 'XMLHttpRequest'
    //                 },
    //                 body: JSON.stringify({
    //                     updates: {},
    //                 }),
    //             })
    //                 .then(function (response) {
    //                     return response.json();
    //                 })
    //                 .then(function (cart) {
    //                     if (cart.items_subtotal_price == cart.original_total_price) {
    //                         $(".discount__total").html('');
    //                         $('.discount-wrapper').removeClass('error-message').addClass('success-message');
    //                         $('.discount-wrapper .success').removeClass('hidden');
    //                         $('.discount-wrapper .error').addClass('hidden');
    //                         $('.discount-message').removeClass('hidden').text('The discount code has been removed.');
    //                         $('.Cart__Total.discount__total span:last').text('-$' + (cart.total_discount / 100).toFixed(2));
    //                         $('.Cart__Total.total__all span:last').text('$' + ((cart.original_total_price - cart.total_discount) / 100).toFixed(2));
    //                         $('#cart-discount-input').val('');
    //                         $('#coupon_applied').val('');
    //                         $('#cart-discount-input').removeClass('input-invalid');

    //                         $('.gr__discount__title').html('');

    //                     }

    //                 })
    //                 .catch(function (error) {
    //                     console.error('Error:', error);
    //                 });
    //         });
    //     }
    // });

    function disableDeleteButton(isChecked) {
        const deleteButton = $('#delete-all');
        if (!isChecked) {
            deleteButton.addClass('disabled');
        } else {
            deleteButton.removeClass('disabled');
        }
    }

});

$(document).ready(function () {
    $('body').on('click', '.login__function__cart .gb .js__click', function () {
        $(".icon__login").trigger("click");
    });
    // setTimeout(function () {
    //     let coupon_applied = $('#coupon_applied').val();
    //     if (coupon_applied != '') {
    //         $('.promo__my__cart h2').addClass('active');
    //     }
    // }, 4000);



});